// database.js

import cloudbase from '@cloudbase/js-sdk';
import login from '@/api/wxlogin';

const app = cloudbase.init({
    env: 'test-2g6ta6vb3b0b7b16' // 填入您的环境 ID
});

login();

const db = app.database();

export default db;



// WEBPACK FOOTER //
// ./src/api/database.js